import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { RounderUtil } from 'utils'

const PorcentajeDescuentoFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, values, setValues }) => {
  return (
    <Form.Group>
      <Form.Label text='DESCUENTO %' htmlFor='select-porcentajeDescuento' xs={12} />
      <Col xs={12}>
        <Field name='porcentajeDescuento'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-porcentajeDescuento'
              onChange={e => {
                handleChange(e)
                if (e.target.value) {
                  const fieldValue = parseFloat(e.target.value)
                  values.porcentajeDescuento = fieldValue
                  const discountAmount = (values.precioLista * values.porcentajeDescuento) / 100
                  values.precioNeto = RounderUtil(values.precioLista - discountAmount, 4)
                  setValues(values)
                } else {
                  values.porcentajeDescuento = e.target.value
                  values.precioNeto = values.precioLista
                  setValues(values)
                }
              }}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PorcentajeDescuentoFormGroup)
